import { BasicStylistFragment } from 'drycut-graphql';
import { Para } from 'ui-components';
import { formatStylistNames } from 'ui-format-utils';

type Props = {
  stylists?: BasicStylistFragment[];
} & React.ComponentProps<typeof Para>;

export default function StylistList({ stylists = [], ...props }: Props): JSX.Element {
  const names = stylists.map((stylist) => stylist.name);

  return (
    <Para {...props}>
      Stylisten im Salon: <strong className="font-aribaubold">{formatStylistNames(names)}</strong>
    </Para>
  );
}
